export class CustomException extends Error {
  errorCode: number;

  errorMessage?: string;

  errors?: CustomException[];

  constructor(code: number, message: string, errors?: CustomException[]) {
    super(message);
    this.errorCode = code;
    this.errorMessage = message;
    this.errors = errors;
  }
}
